export default "__VITE_ASSET__Cwxz6kEc__"